import React from 'react';
import { CTAButton } from './CTAButton';
import { FadeIn } from './FadeIn';
export function CTABreak() {
  return <section className="py-6 md:py-12 px-4 bg-gradient-to-r from-kid-yellow/5 via-background-cream to-kid-yellow/5 border-y border-kid-yellow/20 relative z-10" data-id="element-96">
      <div className="max-w-3xl mx-auto text-center" data-id="element-97">
        <FadeIn data-id="element-98">
          <CTAButton text="QUIERO EL SISTEMA DE LECTURA »" size="lg" className="w-full sm:w-auto" animatePulse={true} data-id="element-99" />
          <div className="mt-3 md:mt-4 text-xs md:text-sm text-gray-600 font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-100">
            <span data-id="element-101">Acceso inmediato</span>
            <span className="text-gray-300" data-id="element-102">·</span>
            <span data-id="element-103">Pago único</span>
            <span className="text-gray-300" data-id="element-104">·</span>
            <span data-id="element-105">Sin suscripciones</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}